import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { Injector } from '@angular/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ChargingStationStatusHistoryDto } from '@dto/chargingStationStatusHistoryDto';
import { TableColumn } from '@models/tableColumn';
import { TableFilter } from '@models/tableFilter';
import { TableOptions } from '@models/tableOptions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { plainToClass } from 'class-transformer';
import { DEDatePipe } from 'src/app/pipes/de-date.pipe';

@Component({
  selector: 'app-charging-stations-status-history-table',
  templateUrl: './charging-stations-status-history-table.component.html',
  styleUrls: ['./charging-stations-status-history-table.component.scss']
})
export class ChargingStationsStatusHistoryTableComponent extends AbstractEntitiesTableComponent implements OnInit, OnDestroy {

  public className = 'ChargingStationsStatusHistoryTableComponent';

  public entities: ChargingStationStatusHistoryDto[];

  public customerId: number;
  public filter: TableFilter;
  

  public tableColumns: TableColumn[] = [
    { columnDescription: $localize`:@@ChargingStationsStatusHistoryTableColumn1:Name/Bezeichner`, property: 'chargingStationName', options: { routerLink: 'edit/{chargingStationId}' } },
    { columnDescription: $localize`:@@ChargingStationsStatusHistoryTableColumn4:ConnectorId`, property: 'connectorId'},
    { columnDescription: $localize`:@@ChargingStationsStatusHistoryTableColumn2:Status`, property: 'displayStatus', options: { 'isHTML': true } },
    { columnDescription: $localize`:@@ChargingStationsStatusHistoryTableColumn3:Zeitpunkt`, property: 'timestamp', options: { columnPipe: { pipe: new DEDatePipe() } } },
  ];

  public tableOptions: TableOptions = { hideActions: true };

  constructor(public chargingStationsService: ChargingStationsService, private dialog: NgbModal, injector: Injector) {
    super(chargingStationsService, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.tableFunctions.sortColumn = 'timestamp';
    this.tableFunctions.sortDirection = 'desc';
  }

  async initializeEntities() {
    this.customerId = this.activatedRoute.parent.snapshot.params.key;
  }

  mapStatus() {
    this.entities.forEach(e => {
      switch (e.statusId) {
        case 1:
          e.displayStatus = "<span class='badge rounded-pill bg-primary'>" + e.status.name + "</span>";
          break;
        case 2:
          e.displayStatus = "<span class='badge rounded-pill bg-success'>" + e.status.name + "</span>";
          break;
        case 3:
          e.displayStatus = "<span class='badge rounded-pill bg-warning' style='background-color:orange'>" + e.status.name + "</span>";
          break;
        case 4:
          e.displayStatus = "<span class='badge rounded-pill bg-danger'>" + e.status.name + "</span>";
          break;
        case 5:
          e.displayStatus = "<span class='badge rounded-pill bg-info'>" + e.status.name + "</span>";
          break;
        case 6:
          e.displayStatus = "<span class='badge rounded-pill bg-info'>" + e.status.name + "</span>";
          break;
        case 7:
          e.displayStatus = "<span class='badge rounded-pill bg-reserved'>" + e.status.name + "</span>";
          break;
        case 8:
          e.displayStatus = "<span class='badge rounded-pill bg-info'>" + e.status.name + "</span>";
          break;
        case 9:
          e.displayStatus = "<span class='badge rounded-pill bg-info'>" + e.status.name + "</span>";
          break;
        case 10:
          e.displayStatus = "<span class='badge rounded-pill bg-danger'>" + e.status.name + "</span>";
          break;
        case 11:
          e.displayStatus = "<span class='badge rounded-pill bg-secondary'>" + e.status.name + "</span>";
          break;
        default:
          e.displayStatus = "<span class='badge rounded-pill bg-secondary'>" + e.status.name + "</span>";
          break;
      }
    })
  }

  matches(entity: ChargingStationStatusHistoryDto, term: string) {
    var datePipe = new DEDatePipe();
    var timestamp = datePipe.transform(entity.timestamp);

    return entity.chargingStationName?.toLocaleLowerCase().includes(term.toLowerCase())
      // || entity.status?.name?.toLowerCase().includes(term.toLowerCase())
      || timestamp?.includes(term.toLowerCase())
  }

  setFilter(filter: TableFilter) {
    filter.filterDLM = false;
    filter.filterSignal = false;
    this.filter = filter;
    this.updateTable();
  }

  async updateTable() {
    this.chargingStationsService.getCharingStationsHistoryTableOfCustomer(this.customerId, this.filter).subscribe(result => {
      this.entities = plainToClass(ChargingStationStatusHistoryDto, result);
      this.mapStatus();
      super.setupTable();
    }, error => {});
  }
}
